"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const CloseIcon_1 = __importDefault(require("../Icons/CloseIcon"));
const S = __importStar(require("./Tag.styles"));
const Tag = (props) => {
    const { children = null, strikedText, type = 'primary', onPress, icon = false, closeButtonClb, } = props;
    // const textType = type;
    // eslint-disable-next-line sonarjs/no-small-switch
    switch (type) {
        case 'filter':
            return (react_1.default.createElement(S.FilterTag, { onPress: onPress, testID: "PressableTag", type: type },
                children && react_1.default.createElement(S.FilterText, { type: type }, children),
                react_1.default.createElement(S.CloseIconWrapper, null,
                    react_1.default.createElement(CloseIcon_1.default, { width: "8px" }))));
        default:
            return (react_1.default.createElement(S.Tag, { testID: "Tag", type: type },
                icon && react_1.default.createElement(S.IconWrapper, null, icon),
                !!strikedText && (react_1.default.createElement(S.StrikeThroughText, { type: type }, strikedText)),
                children && react_1.default.createElement(S.Text, { type: type }, children),
                closeButtonClb && (react_1.default.createElement(S.CloseIconWrapper, null,
                    react_1.default.createElement(react_native_1.TouchableOpacity, { accessibilityRole: "button", onPress: closeButtonClb },
                        react_1.default.createElement(CloseIcon_1.default, { width: "8px" }))))));
    }
};
exports.default = react_1.default.memo(Tag);
